/**
 * RESPONSIBILITY: the Special Events band.
 *
 * Reads the SAME events list as every other band — a special event is an event with
 * `special` ticked, not a different kind of thing kept somewhere else. So its pencil is
 * the events pencil, and moving an event in or out of this band is a checkbox rather
 * than retyping it in a second list.
 */
import { idOf } from '@framework/core';
import type { EventsSection, EventRow } from '@app/sections';
import { EventCard } from './EventCard';

export function EventsSpecial({ c, events }: { c: EventsSection; events: EventRow[] }) {
  if (events.length === 0) return null;

  return (
    <section className="band">
      <div className="wrap">
        <div className="band-head">
          <div>
            <h2>{c.specialHeading}</h2>
            {c.specialIntro && <p className="lede">{c.specialIntro}</p>}
          </div>
        </div>
        <div className="grid grid-3">
          {events.map((e) => <EventCard key={idOf(e)} e={e} />)}
        </div>
      </div>
    </section>
  );
}
